import $ from "jquery";
import _ from "underscore";

export default function (data, options) {
  this.count = data.count;
  this.per_page = data.per_page || 50;
  this.num_pages = Math.ceil(this.count / this.per_page);
  this.current = data.number ? parseInt(data.number) : 1;
  this.next = data.next || this.current < this.num_pages;
  this.previous = data.previous || this.current > 1;

  unbindEvents();

  options.container
    .on("click", ".pagination [data-url]", function () {})
    .on("click", ".pagination [data-page]", function () {
      var page = $(this).attr("data-page");

      if (options.form) {
        unbindEvents();
        options.form.find("[name='page']").val(page);
        options.form.submit();
      } else if (options.on_change) {
        unbindEvents();
        options.on_change(page);
      } else if (options.url) {
        unbindEvents();
        var args = options.args || {};
        args.page = page;
        $.get(options.url, args, onSuccess);
      }
    });

  function unbindEvents() {
    options.container
      .off("click", ".pagination [data-url]")
      .off("click", ".pagination [data-page]");
  }

  function onSuccess(response) {
    if (options.onSuccess) {
      options.onSuccess(response);
    }
  }

  this.render = function () {
    var tmpl = _.template(
      '\
      <%\
      var ranges = [];\
      if (num_pages < 10){\
        ranges.push([1, num_pages]);\
      } else {\
        if (current == 6){\
          ranges.push([1, Math.min(8, num_pages)]);\
        } else {\
          if (current > 5){\
            ranges.push([1, 2])\
          }\
          var page_interval_start = Math.max(current-2, 1);\
          var page_interval_end = Math.min(current+2, num_pages);\
          if (page_interval_end >= num_pages - 2){\
            page_interval_end = num_pages;\
          }\
          ranges.push([page_interval_start, page_interval_end]);\
        }\
        if (current < num_pages - 4){\
          ranges.push([num_pages-1, num_pages]);\
        }\
      }\
      %>\
      <% if (num_pages > 1){ %>\
        <div class="pagination">\
          <ul>\
            <% if (previous){ %>\
              <li class="previous">\
                <span class="fui-arrow-left" data-page="<%= (current-1) %>"></span>\
              </li>\
            <% } else { %>\
              <li class="previous disabled">\
                <span class="fui-arrow-left"></span>\
              </li>\
            <% } %>\
\
            <% _.each(ranges, function(range, j){ %>\
              <% for (var i=range[0]; i<=range[1]; i++){ %>\
                <li<% if (i == current){ %> class="active"<% } %>>\
                  <span data-page="<%= i %>"><%= i %></span>\
                </li>\
              <% } %>\
              <% if (j < ranges.length - 1){ %>\
                <li>\
                  <span class="no-hover">...</span>\
                </li>\
              <% } %>\
            <% }) %>\
\
            <% if (next){ %>\
              <li class="next">\
                <span class="fui-arrow-right" data-page="<%= (current+1) %>"></span>\
              </li>\
            <% } else { %>\
              <li class="next disabled">\
                <span class="fui-arrow-right"></span>\
              </li>\
            <% } %>\
          </ul>\
        </div>\
      <% } %>'
    );
    return tmpl(this);
  };

  this.unbindEvents = unbindEvents;

  return this;
}
